export const MEDUSA_BACKEND_URL =
  document?.body?.dataset?.medusaApiUrl ||
  window["__API_URL__"] ||
  process.env.MEDUSA_BACKEND_URL ||
  __MEDUSA_BACKEND_URL__ ||
  "http://localhost:9000"
